export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11085.71e8af85.jpg";